import React from "react";
import { Button, StyledText } from "../../../../components/common";
import { SuccessBoxIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 100;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 100;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 0px 20px;
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin-top: 70%;
  border-top-right-radius: 0px;
  border-top-left-radius: 15px;
`;

const PointsText = styled.span`
  font-family: "MTNBold";
`;

const SurveyRewardRedemptionModal = ({ isOpen, onClose }) => {
  const { themeContext, theme } = useTheme();
  const history = useHistory();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  const token = JSON.parse(localStorage.getItem("token"));

  if (!isOpen) return null;

  let points = 50; // using a dummy point data

  return (
    <>
      <ModalOverlay onClick={onClose} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <StyledText style={{ fontSize: 20 }}>Redemption Successful</StyledText>
        <SuccessBoxIcon width="112" height="112" fill={background} />
        <Button
          style={{
            backgroundColor: background,
            width: "80%",
            marginTop: "11px",
          }}
          onClick={() => history.push(`/home?token=${token}`)}
        >
          <StyledText color="white">Go Home</StyledText>
        </Button>
        <Button
          style={{
            backgroundColor: "white",
            width: "80%",
            border: "2px solid #333",
            marginTop: "11px",
          }}
          onClick={() => {
            history.push(`/event_survey`);
          }}
        >
          <StyledText color="#333">Go back to survey</StyledText>
        </Button>
      </ModalContent>
    </>
  );
};

export default SurveyRewardRedemptionModal;
